// extracted by mini-css-extract-plugin
export default {"content":"lM-z","lookName":"mM-z","shopTheLookContainer":"nM-z","productContainer":"oM-z","imageContainer":"pM-z","mainImage":"qM-z"};